import { render, staticRenderFns } from "./SelfServiceFooter.vue?vue&type=template&id=44e2c78c"
import script from "./SelfServiceFooter.vue?vue&type=script&lang=js"
export * from "./SelfServiceFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports